import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { updateArea, getAreas, setCurrentArea, removeArea } from '../../actions/areaActions';
import { toggleModal } from '../../actions/modalActions';

const SYNGEOS_URL = 'https://panel.syngeos.pl/sensor/pm10'
const SCREEN_URL = 'https://panel.syngeos.pl/sensor/pm10'

class SingleArea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            edited: false,
            name: this.props.areaName,
            areaIframe: "",
            areaLink: "",
            screenLink: "",
        }
    }

    generateLink = () => {
        const { areaId, deviceId } = this.props;
        if (deviceId) {
            this.setState({
                areaIframe: "<iframe src=\"" + SYNGEOS_URL + "?device=" +
                deviceId + "&areaId=" + areaId + "\"></iframe>",
                areaLink: SYNGEOS_URL + "?device=" +
                deviceId + "&areaId=" + areaId,
                screenLink: SCREEN_URL + "?device=" +
                deviceId + "&areaId=" + areaId +"&screen=true",
            })
        } else {
            this.setState({
                areaIframe: this.props.intl.formatMessage({id: 'dashboard.area.no.device'}),
                areaLink: "",
                screenLink: this.props.intl.formatMessage({id: 'dashboard.area.no.device'}),
            })
        }
    }

    componentDidMount = () => {
        this.generateLink();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.deviceId !== prevProps.deviceId) {
            this.generateLink();
          }
    }

    onAreaUpdate = () => { 
        const { areaId, areaName, updateArea, getAreas } = this.props;
        const { name, edited } = this.state;

        if ((!name && areaName))  {
            return;
        }

        if (edited && (name !== areaName)) {
            const data = {
                name: name
            };

            updateArea(areaId, data).then(() => getAreas());
        }

        this.setState({ edited: !edited });
    }

    toggleDeviceListModal = () => {
        this.props.setCurrentArea(this.props.areaId); 
        this.props.toggleModal('AreaDeviceListModal');
    }

    removeArea = () => {
        this.props.removeArea(this.props.areaId).then(() => this.props.getAreas());
    }

    renderCopyArea = (areaIframe, areaLink) => {
        return (
            <div className="d-flex align-items-center">
                <textarea
                    readOnly
                    rows="2"
                    cols="45"
                    value={areaIframe}
                >
                </textarea>
                <CopyToClipboard text={areaIframe}>
                    <button
                        className="btn btn-primary btn--fixed-width m-2"
                        type="button"
                    >
                        <FormattedMessage id="dashboard.buttons.area.copy" />
                    </button>
                </CopyToClipboard>
                <button
                    disabled={!this.state.areaLink}
                    className="btn btn-info btn--fixed-width m-2"
                    type="button"
                    onClick={()=> window.open(areaLink, "_blank")}
                >
                    <FormattedMessage id="dashboard.buttons.area.show.preview" />
                </button>
            </div>
        )
    }

    render() {
        const { areaId, areaName } = this.props;
        const { name, edited, areaLink, areaIframe, screenLink } = this.state;

        return (
            <tr>
                <td>
                    <div>{`${areaId}`}</div>
                </td>
                <td className="col-3">
                    {!edited ? (
                        <div>{`${areaName}`}</div>
                    ) : (
                        <div>
                            <input
                                id="group-name"
                                className="form-control"
                                type="text"
                                value={name}
                                onChange={e => {
                                    this.setState({
                                        name: e.target.value
                                    });
                                }}
                            />
                        </div>
                    )}
                </td>
                {
                    <td>
                        <button
                            className="btn btn-primary btn--fixed-width"
                            type="button"
                            onClick={this.toggleDeviceListModal}
                        >
                            <FormattedMessage id="dashboard.buttons.area.show.list" />
                        </button>
                    </td>
                }
                <td>
                    <div className="d-flex align-items-center">
                        {this.renderCopyArea(areaIframe, areaLink)}
                    </div>
                    <div className="d-flex align-items-center">
                        {this.renderCopyArea(screenLink, screenLink)}
                    </div>
                </td>
                <td className="text-right">
                    {edited ? (
                        <div>
                            <button
                                className="btn btn-success btn--fixed-width m-2"
                                onClick={this.onAreaUpdate}
                            >
                                <FormattedMessage id="dashboard.buttons.area.accept" />
                            </button>
                            <button
                                className="btn btn-danger btn--fixed-width m-2"
                                onClick={() => {
                                    this.setState({
                                        name: areaName,
                                        edited: !edited
                                    });
                                }}
                            >
                                    <FormattedMessage id="dashboard.buttons.area.cancel" />
                            </button>
                        </div>
                    ) : (
                        <div>
                            <button
                                className="btn btn-primary btn--fixed-width m-2"
                                onClick={this.onAreaUpdate}
                            >
                                <FormattedMessage id="dashboard.buttons.area.edit" />
                            </button>
                            <button
                                className="btn btn-danger btn--fixed-width m-2"
                                onClick={this.removeArea}
                            >
                                    <FormattedMessage id="dashboard.buttons.area.delete" />
                            </button>
                        </div>
                    )}
                </td>
            </tr>
        );
    }
}

export default connect(null, (
    { updateArea, getAreas, setCurrentArea, removeArea, toggleModal }
))(injectIntl(SingleArea));



// WEBPACK FOOTER //
// ./src/components/SingleArea/SingleArea.js